import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  InstaPointsBentoCard,
  BentoHeader,
  InstaPointOverviewRow,
  InstaPointOverviewCol,
  InstaPointVerticalDivider
} from '../../../screens/dashboard-revamp/components/refer-instapoints/style';
import { skeletonProps } from '../Shimmer.types';

export const ShimmerDashboardIP: React.FC = () => (
  <InstaPointsBentoCard>
    <BentoHeader>
      <Skeleton {...skeletonProps} width={140} height={24} />
      <Skeleton {...skeletonProps} width={70} height={20} />
    </BentoHeader>
    <InstaPointOverviewRow>
      <InstaPointOverviewCol>
        <Skeleton {...skeletonProps} width={70} height={16} />
        <Skeleton {...skeletonProps} width={110} height={32} borderRadius={400} />
      </InstaPointOverviewCol>
      <InstaPointVerticalDivider />
      <InstaPointOverviewCol>
        <Skeleton {...skeletonProps} width={100} height={16} />
        <Skeleton {...skeletonProps} width={110} height={32} borderRadius={400} />
      </InstaPointOverviewCol>
    </InstaPointOverviewRow>
  </InstaPointsBentoCard>
);

export default ShimmerDashboardIP;
